import { ROUTE_NAME } from 'utils/constants/router';

export const GA = {
  category: 'Upload',
  events: {
    pageview: 'Upload file landing page viewed',
    browse: 'Clicking on browse',
    dragFile: 'Drag a file',
    sendRecord: 'Clicking on Send record by mail',
    answerManually: 'Clickin on Answer manually',
    emailToLater: 'Upload file clicking continue later',
    emailToLaterForm: 'Continue later form viewed',
    emailToLaterPopup: 'Continue later final popup viewed',
    moreUpload: 'Upload more clicked',
    next: 'Clicking on “Next”',
    startVideo: 'Upload file video started',
    endVideo: 'Upload file video finished',
    fileSuccessfully: 'Upload file extracted successfully',
    fileFailed: 'Upload file extracted failed',
    reviewing: 'When the revireing page is presented',
    confirmaed: 'When confirmaed',
    success: 'signup_success',
    error: 'signup_error',
  },
};

export const UPLOAD_VIMEO_IDS = {
  [ROUTE_NAME.UPLOAD]: '944032597',
  [ROUTE_NAME.SEARCH]: '995786509',
};
